var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 89 1580",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 20,
    x: 40,
    width: 70,
    height: 1500,
    rx: 15,
    fill: "#3ab73e",
    opacity: 0.6,
    stroke: "none",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.514 44.04c-.615.032-1.164.271-1.679.351-2.572.405-3.688 1.332-1.266 1.859-2.594.534-6.639-.204-8.582-.552-.302-.571 5.243-2.627 11.301-2.482.291.317.373.47.226.824h.001",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.872 46.633c-2.711.973-14.733 2.844-8.563 4.19-2.594.532-6.363.675-8.304.325-.342-.642 3.925-2.721 7.583-2.996 2.982-.125 5.509-.306 9.283-1.519",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.486 53.153c-2.375.853-12.902 2.492-7.498 3.67-2.273.467-5.259.607-6.96.303-.3-.564 3.125-2.399 6.329-2.641 2.612-.11 4.825-.268 8.13-1.331",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.64 43.451c.464.347.794.871.853 1.44.232 1.822-4.876 3.049-10.103 3.43-5.218.489-10.49.127-10.63-1.704-.041-.385.048-.773.229-1.112 1.496.335 3.152.571 4.988.689 3.583.231 6.845-.047 9.784-.83 1.771-.471 3.398-1.11 4.88-1.912",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.754 50.3c-1.135 1.57 10.964.207 15.984-.542 1.163-.209 2.305.734 2.418 1.837.233 1.824-4.873 3.052-10.103 3.431-8.876.836-10.887-3.398-8.299-4.726",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.47 56.496c-.72.997 3.754.54 5.775.365 2.022-.162 4.012-.412 5.963-.763.854-.154 1.692.539 1.775 1.35.171 1.339-3.578 2.241-7.419 2.519-6.518.613-7.995-2.495-6.094-3.47 M63.339 58.024c-2.973 1.485-5.814 3.186-7.698 5.678l-.275-.085 1.009.317c1.141.736 1.115 2.204.359 4.128.207.059.439.071.619.177.586.352.109 1.265-.468 1.127l-1.53-.359c-.201.708-.426 1.415-.606 2.129-.116.468-1.549.374-1.383-.415.148-.706.336-1.389.509-2.036l-.721-.177-.711-.162c-.201.641-.425 1.368-.63 2.01-.185.574-1.57.346-1.432-.251.168-.714.421-1.415.633-2.123-.511-.12-1.04-.19-1.531-.361-.577-.199-.357-1.059.036-1.113.215-.03.594.005.807.043.388-2.01 1.163-3.301 2.56-3.439l.872.134c1.305-2.929 4.118-4.725 7.213-6.187l2.367.965",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.905 12.377l-.105.023c-7.636 1.782-13.179 8.122-12.953 15.525.195 6.424 4.863 11.446 10.907 14.067 2.294.995 2.283 1.814 1.481 2.288 3.633-.276 2.163-2.505 1.801-3.443-2.398-6.225-10.97-14.443-7.024-20.214-2.564 6.784 11.024 15.568 8.132 21.952 13.799-18.188-11.368-18.807-2.24-30.197",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo_small.cb2b8f383f213788b8e5595b4e344599.svg";
export { ForwardRef as ReactComponent };